import createSelectors from './createSelectors';
import QuestionnaireFilterOption from '../models/QuestionnaireFilterOption';

const Select = createSelectors(QuestionnaireFilterOption, {});

export default Select;
